import router from "@/router";
import {mapGetters} from "vuex";

export const ModelViewMixin= {
    computed: {
        ...mapGetters({
            activePlanModel: 'smartLogisticSettings/planModel'
        })
    },

    created () {
        this.$store.dispatch('bilder/fetchImages')
        this.$store.dispatch('articles/fetchCategoriesSortArray')
        this.$store.dispatch('articles/fetchArticleInfos')
        this.$store.dispatch('articles/fetchMySortiment')
        this.$store.dispatch('articleSettings/fetchArticleSettings')

        // firewall to ensure that customer has model c or b
        // since smartLogistics settings are fetched outside this vue, it is necessary to check the model via interval as model a is default
        let intervalCounter = 0
        const interval = setInterval(() => {
            if (['b', 'c'].includes(this.activePlanModel)) {
                this.modelTypeResolved = true
                clearInterval(interval)
            }

            if (intervalCounter > 50) {
                clearInterval(interval)
                router.push('/versorgungsplan')
            }

            intervalCounter++
        }, 50)
    }
}